/* ------------------------------------------------------------------------------------------------------------------------------
				                    Footer Link Nudge Starts
------------------------------------------------------------------------------------------------------------------------------ */    
$(document).ready(function() {		    
		
	
	$(".linkNudge").hover(function()
		{
			$(this).animate({ left: '10px' }, 100);
		}, function() {
			$(this).animate({ left: 0 }, 100);
	});
				
}); 

/* ------------------------------------------------------------------------------------------------------------------------------
					     Footer Link Nudge Starts
------------------------------------------------------------------------------------------------------------------------------ */





/* ------------------------------------------------------------------------------------------------------------------------------
				           Clear Search Store Field On Focus Starts
------------------------------------------------------------------------------------------------------------------------------ */    



$(document).ready(function() {		    
		
	
	$(".searchStoreFormInput").focus(function(){
		if (this.value == "Search Store..." ) $(this).attr("value", "");
		
	});
	
	$(".searchStoreFormInput").blur(function(){
		if (this.value == "" ) $(this).attr("value", "Search Store...");
		
	});
				
}); 



/* ------------------------------------------------------------------------------------------------------------------------------
					   Clear Search Store Field On Focus Ends
------------------------------------------------------------------------------------------------------------------------------ */








